import { Link, useParams } from "react-router-dom";
import {useEffect, useRef, useState } from "react";
import $ from 'jquery';
import apiClient from "../../http-common";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { HTTPURL } from "../../constants/matcher";
import Loader from "react-js-loader";
import "../../css/profile.css";
import {useFetch, useFetchApi, useFetchMyApi1, useFetchMyApi2} from "../../customHooks/useFetch";

const GetServant = () => {
    const segments = window.location.pathname.split("/");
    var user_type = segments[segments.length - 3]

    // const [data] = useFetch("https://jsonplaceholder.typicode.com/todos");
    // console.log("Data is-->>", data)

    // const [items1, locationFetch] = useFetchMyApi(); // <-- destructure state and fetch function
    // useEffect(() => {
    //     locationFetch("mylocation1");
    // }, []); // <-- initial mounting fetch call
    // console.log("items are--", items)

    // const [location, setLocation] = useState("mylocation1"); // <-- add state
    // const { items2 } = useFetchMyApi2(location); // <-- pass location value to hook
    // console.log("items2 is-->>", items2)

    // function commonFetch() {
    //     locationFetch("mylocation22");
    //     setLocation("loc --22222222");
    // }

    // const [reqData, setreqData] = useState([]); // <-- add state
    // const { resData } = useFetchApi(reqData); // <-- pass location value to hook

    // const callFetch = (user_id) => {
    //     setreqData("https://jsonplaceholder.typicode.com/todos");
    // };

    // useEffect( () => {
    //     console.log("resData is-->>", resData)
    // }, [resData]);

    ////////////////////////////
    const [toggleState, setToggleState] = useState(1);
    const toggleTab = (index) => {
      setToggleState(index);
    };

    var {user_id} = useParams();

    const [user, setUser] = useStateWithCallbackLazy([]);
    const [showResults, setShowResults] = useState(false);
    
    useEffect( () => {
        // const [data] = useFetch("https://jsonplaceholder.typicode.com/todos");
        // console.log("Data is-->>", data)

        getUser(user_id);
        // callFetch(user_id);

          
        // callFetch(user_id);
    }, []);

    // const callFetch = (user_id) => {
    //     console.log("user id is-->>", user_id)

    //     const [data] = useFetch("https://jsonplaceholder.typicode.com/todos");
    //     console.log("Data is-->>", data)
    // };

    async function getUser() {
        try {
            const res = await apiClient.get("/admin/get-user/"+user_id);
            console.log('res',res);
            setUser(res.data.data[0], () => {
                setShowResults(true)
            });

        } catch (err) {
            console.log(err)
        }
    }
        
    const Results = () => (
        <div className="container emp-profile">
            <form method="post">
                <div className="row">
                    <div className="col-md-4">
                        <div className="profile-img">
                            {/* <img src={HTTPURL+'images/'+user.photo} alt="No Image"/> */}
                            <img src={HTTPURL+'images/'+(user.photo?user.photo:'default.png')} alt="No Image"/>
                            {/* <div className="file btn btn-lg btn-primary">
                                Change Photo
                                <input type="file" name="file"/>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="profile-head">
                            <h5>
                                {user.firstName+' '+user.middleName+' '+user.lastName}
                            </h5>
                            <h6>
                                {user.email}
                            </h6>

                            <p className="proile-rating">USER TYPE : <span>{user_type=='civil-servants' ? 'Civil-Servant' : 'Mentor'}</span></p>
                            
                            {/* <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">About</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Timeline</a>
                                </li>
                            </ul> */}

                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <button
                                        className={toggleState === 1 ? "nav-link active" : "nav-link"}
                                        onClick={() => toggleTab(1)}
                                        >
                                        Info
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={toggleState === 2 ? "nav-link active" : "nav-link"}
                                        onClick={() => toggleTab(2)}
                                        >
                                        Detail
                                    </button>
                                </li>
                                {/* <li className="nav-item">
                                    <button
                                        className={toggleState === 3 ? "nav-link active" : "nav-link"}
                                        onClick={() => toggleTab(3)}
                                        >
                                        Tab 3
                                    </button>
                                </li> */}
                            </ul>

                        </div>
                    </div>
                    {/* <div className="col-md-2">
                        <input type="submit" className="profile-edit-btn" name="btnAddMore" value="Edit Profile"/>
                    </div> */}
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="profile-work">
                            <p>Contact</p>
                            <b>{user.phone}</b><br/>
                            <b>{user.address}</b><br/>
                            
                            <p>Survey</p>
                            <b>Similer Training : {user.similer_training?(user.similer_training=='1'?'Yes':'No'):''}</b><br/>
                            <b>Course Relevant : {user.course_relevant?(user.course_relevant=='1'?'Yes':'No'):''}</b><br/>
                            <b>Past Training : {user.past_training?(user.past_training=='1'?'Yes':'No'):''}</b><br/>
                            <b>Self Sponsored : {user.self_sponsored?(user.self_sponsored=='1'?'Yes':'No'):''}</b><br/>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="tab-content profile-tab" id="myTabContent">
                            <div className={toggleState === 1 ? "tab-pane fade show active" : "tab-pane fade"} id="home" role="tabpanel" aria-labelledby="home-tab">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>DOB</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{user.dob}</p>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Gender</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{user.gender==0?'Male':'Female'}</p>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Marital Status</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{user.maritalStatus==0?'Married':'Unmarried'}</p>
                                    </div>
                                </div>
                            </div>

                            <div className={toggleState === 2 ? "tab-pane fade show active" : "tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Category</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{user.cname}</p>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Sub Category</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{user.subcategory}</p>
                                    </div>
                                </div>

                                {user_type == 'civil-servants' ? 
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Civil Service Code</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{user.civilServiceCode}</p>
                                        </div>
                                    </div> 
                                : null}

                                {user_type == 'mentors' ? 
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Education</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{user.ename}</p>
                                        </div>
                                    </div> 
                                : null}

                                {user_type == 'mentors' ? 
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Work/Vocation</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{user.wvname}</p>
                                        </div>
                                    </div> 
                                : null}

                            </div>
                        </div>
                    </div>
                </div>
            </form>           
        </div>
    )

    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">{user_type=='civil-servants' ? 'Civil Servants' : 'Mentors'}</h1>
                <ol className="breadcrumb mb-4">
                    <Link to="../../dashboard" className="breadcrumb-item">Dashboard</Link>
                    <Link to={`../../${user_type=='civil-servants' ? 'civil-servants' : 'mentors'}`} className="breadcrumb-item">{user_type=='civil-servants' ? 'Civil Servants' : 'Mentors'}</Link>
                    <Link className="breadcrumb-item active">View</Link>
                </ol>

                <div className="card mb-4">
                    <div className="card-header">
                        <i className="fas fa-table me-1"></i>
                        {user_type=='civil-servants' ? 'Civil-Servant' : 'Mentor'} Detail
                    </div>
                    <div className="card-body">
                        {/* { showResults ? <Results /> : null } */}
                        { showResults ? <Results /> : <Loader type="spinner-circle" bgColor={"black"} title={"Loading Data..."} color={'black'} size={100} /> }
                    </div>
                </div>
            </div>
        </main>
    )
};

export default GetServant;